import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MobilePhoneIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 2.86526H10.5C11.0523 2.86526 11.5 3.31298 11.5 3.86526V12.8653C11.5 13.4176 11.0523 13.8653 10.5 13.8653H5.5C4.94772 13.8653 4.5 13.4176 4.5 12.8653V3.86526C4.5 3.31298 4.94772 2.86526 5.5 2.86526H6V3.36526C6 3.91754 6.44772 4.36526 7 4.36526H9C9.55228 4.36526 10 3.91754 10 3.36526V2.86526ZM3 3.86526C3 2.48455 4.11929 1.36526 5.5 1.36526H10.5C11.8807 1.36526 13 2.48455 13 3.86526V12.8653C13 14.246 11.8807 15.3653 10.5 15.3653H5.5C4.11929 15.3653 3 14.246 3 12.8653V3.86526Z"
			/>
		</svg>
	),
)
